/* jshint esnext:true */

import ReactDOM from 'react-dom';

export default function unmountMessageForm(container) {
    ReactDOM.unmountComponentAtNode(container);
}
